import { Children, useEffect, } from 'react';
import { useDragScroll } from './useDragScroll';
import { useSlide } from './useSlide';
export function useScrollSlider({ scrollRef, children, initialChild, onRangeEnd, onClick }) {
    const childrenKeys = Children.toArray(children).map((child) => child.key);
    const { onPointerDown, onPointerMove, onPointerUp } = useDragScroll({ scrollRef });
    const { handleRender, handleScrollBy, handleDragEnd } = useSlide({
        scrollRef,
        childrenKeys,
        onRangeEnd,
        onClick,
    });
    useEffect(() => {
        if (!scrollRef.current)
            return;
        handleRender(`.$${initialChild}`);
    }, [scrollRef, initialChild, childrenKeys, handleRender]);
    const mergedPointerUp = (event) => {
        const dragInfo = onPointerUp(event);
        handleDragEnd(dragInfo);
    };
    return {
        onPointerDown,
        onPointerMove,
        onPointerUp: mergedPointerUp,
        handleScrollBy,
    };
}
